import { UsuarioTipoPermissao } from '@app/models/util/usuario-tipo-permissao';
import { Menu } from '@app/models/util/menu';

export class UsuarioTipo {

  Id: number;
  Descricao: string;
  Menus: Menu[];
  Permissoes: UsuarioTipoPermissao[];
  Padrao: boolean;
  Ativo: boolean;

  constructor() {
    this.Ativo = true;
  }

}
